/**
 * Public-facing reviewer label: first name + last initial (e.g. "William D.").
 */
export function formatPublicReviewerDisplayName(
	firstName?: string | null,
	lastName?: string | null,
	username?: string | null,
): string {
	const f = (firstName ?? "").trim();
	const l = (lastName ?? "").trim();

	if (f && l) {
		const first =
			f.charAt(0).toLocaleUpperCase("en-GB") + f.slice(1).toLocaleLowerCase("en-GB");
		const initial = l.charAt(0).toLocaleUpperCase("en-GB");
		return `${first} ${initial}.`;
	}

	if (f) {
		return f.charAt(0).toLocaleUpperCase("en-GB") + f.slice(1).toLocaleLowerCase("en-GB");
	}

	if (l) {
		return `${l.charAt(0).toLocaleUpperCase("en-GB")}.`;
	}

	const u = (username ?? "").trim();
	if (u) {
		const parts = u
			.replace(/[_\-.]+/g, " ")
			.trim()
			.split(/\s+/)
			.filter(Boolean);
		if (parts.length >= 2) {
			const p0 =
				parts[0].charAt(0).toLocaleUpperCase("en-GB") +
				parts[0].slice(1).toLocaleLowerCase("en-GB");
			const p1i = parts[1].charAt(0).toLocaleUpperCase("en-GB");
			return `${p0} ${p1i}.`;
		}
		return u.charAt(0).toLocaleUpperCase("en-GB") + u.slice(1).toLocaleLowerCase("en-GB");
	}

	return "Customer";
}
